import { createFileRoute } from "@tanstack/react-router"

import { ProfileStep } from "@/features/membership/application/components/profile-step"

export const Route = createFileRoute("/membership/apply/profile")({
  component: ProfileStep,
})
